import { selectSelectedAssetCategoryName, selectSelectedOwnerId } from 'client/store/isolatedViewsSlice/isolatedViewsSlice';
import { useSelector } from 'react-redux';

export const useAssetOwnerIsolatedView = () => {
    const selectedOwner = useSelector(selectSelectedOwnerId);
    const category = useSelector(selectSelectedAssetCategoryName);
    const assetOwnersInAOI = useSelector(state => state?.assetOwners?.data?.assetsInAOIOwners || []);
    const owner = assetOwnersInAOI.find(assetOwner => assetOwner.dataProviderId === selectedOwner);
    const actorName = owner?.label || owner?.actorName || '';

    return {
        id: selectedOwner,
        actorName: actorName,
        category
    };
};
